import React, { Component } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import Header from './Header'

import Help from './Help'
import { getConfiguration } from '../../helpers/configuration'
import AcceptOffer from '../pages/AcceptOffer'
import OfferThankYou from '../pages/OfferThankYou'
import Offers from '../pages/Offers'

class OfferLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      drawerOpen: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div id="app">
        <Header
          onHamburgerClick={() =>
            this.setState({
              drawerOpen: true
            })
          }
        />
        <Help
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false
            })
          }
        />
        
        <Switch>
          <Route path={getConfiguration('baseUrl') + '/offer'} exact component={Offers} />
          <Route path={getConfiguration('baseUrl') + '/offer/accept'} component={AcceptOffer} />
          <Route path={getConfiguration('baseUrl') + '/offer/thankyou'} component={OfferThankYou} />
        </Switch>
             
      </div>
    )
  }
}

export default withRouter(OfferLayout)
